// register.component.ts

import { Component, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { RouterModule, Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { AuthService } from '../../_service/auth.service';
import { UserSettingsService } from '../../_service/user-settings.service';
import { DataService } from '../../_service/data.service';
import { SyncCoordinatorService } from '../../_service/sync/sync-coordinator.service';

const USERNAME_MIN_LENGTH = 3;
const USERNAME_PATTERN = /^[A-Za-z0-9_.-]+$/;
const PASSWORD_MIN_LENGTH = 8;

@Component({
  selector: 'register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
  imports: [CommonModule, FormsModule, RouterModule],
})
export class RegisterComponent implements AfterViewInit {
  @ViewChild('usernameInput') usernameInput!: ElementRef;

  username = '';
  password = '';
  confirmPassword = '';
  errorMessage = '';
  loading = false;

  constructor(
    private authService: AuthService,
    private router: Router,
    private userSettingsService: UserSettingsService,
    private dataService: DataService,
    private syncCoordinator: SyncCoordinatorService,
  ) {}

  ngAfterViewInit(): void {
    this.userSettingsService.loadSavedTheme();
    this.usernameInput.nativeElement.focus();
  }

  onRegister(): void {
    this.errorMessage = '';

    const validationError = this.validate();
    if (validationError) {
      this.errorMessage = validationError;
      return;
    }

    this.loading = true;
    this.authService.register(this.username, this.password).subscribe({
      next: async () => {
        this.loading = false;
        // A brand-new account is always a fresh identity on this device —
        // switch to its own IndexedDB database and reset sync bookkeeping,
        // same as a normal login.
        this.syncCoordinator.onAccountChanged();
        await this.dataService.initialize();
        this.router.navigate(['/home']);
      },
      error: (error) => {
        this.loading = false;
        this.errorMessage = error;
      },
    });
  }

  private validate(): string | null {
    if (this.username.length < USERNAME_MIN_LENGTH) {
      return `Username must be at least ${USERNAME_MIN_LENGTH} characters.`;
    }
    if (!USERNAME_PATTERN.test(this.username)) {
      return "Username may only contain letters, numbers, '.', '_' and '-'.";
    }
    if (this.password.length < PASSWORD_MIN_LENGTH) {
      return `Password must be at least ${PASSWORD_MIN_LENGTH} characters.`;
    }
    if (this.password !== this.confirmPassword) {
      return 'Passwords do not match.';
    }
    return null;
  }
}
